module.exports = "/_next/static/images/Hero-eeb0acf18ce3e166086125be0c1e09a7.webp";